import { render, staticRenderFns } from "./app-promo-card.vue?vue&type=template&id=cd863996&scoped=true&"
import script from "./app-promo-card.vue?vue&type=script&lang=js&"
export * from "./app-promo-card.vue?vue&type=script&lang=js&"
import style0 from "./app-promo-card.vue?vue&type=style&index=0&id=cd863996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd863996",
  null
  
)

export default component.exports